import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { scrollToSection } from "@/lib/scroll-utils";
import { useState } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSectionClick = (sectionId: string) => {
    setIsMenuOpen(false);
    if (window.location.pathname !== '/') {
      // If not on home page, navigate to home first
      window.location.href = `/#${sectionId}`;
    } else {
      // If on home page, just scroll
      scrollToSection(sectionId);
    }
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <span className="text-2xl font-bold text-wiiseng-navy">
                Wii Seng
              </span>
              <span className="text-sm text-wiiseng-blue ml-2 hidden sm:block">
                Technology Resources
              </span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center">
            <button 
              onClick={() => handleSectionClick('home')}
              className="text-wiiseng-gray hover:text-wiiseng-blue transition-colors"
            >
              Home
            </button>
            <button 
              onClick={() => handleSectionClick('services')}
              className="text-wiiseng-gray hover:text-wiiseng-blue transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => handleSectionClick('industries')}
              className="text-wiiseng-gray hover:text-wiiseng-blue transition-colors"
            >
              Industries
            </button>
            <button 
              onClick={() => handleSectionClick('about')}
              className="text-wiiseng-gray hover:text-wiiseng-blue transition-colors"
            >
              About
            </button>
            <Link to="/case-studies" className="text-wiiseng-gray hover:text-wiiseng-blue transition-colors">
              Case Studies
            </Link>
            <Button 
              className="bg-wiiseng-blue hover:bg-wiiseng-navy"
              onClick={() => handleSectionClick('contact')}
            >
              Contact Us
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-wiiseng-gray hover:text-wiiseng-blue focus:outline-none"
            >
              <Menu size={24} />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 animate-fade-in">
            <button 
              onClick={() => handleSectionClick('home')}
              className="block w-full text-left py-2 text-wiiseng-gray hover:text-wiiseng-blue"
            >
              Home
            </button>
            <button 
              onClick={() => handleSectionClick('services')}
              className="block w-full text-left py-2 text-wiiseng-gray hover:text-wiiseng-blue"
            >
              Services
            </button>
            <button 
              onClick={() => handleSectionClick('industries')}
              className="block w-full text-left py-2 text-wiiseng-gray hover:text-wiiseng-blue"
            >
              Industries
            </button>
            <button 
              onClick={() => handleSectionClick('about')}
              className="block w-full text-left py-2 text-wiiseng-gray hover:text-wiiseng-blue"
            >
              About
            </button>
            <Link 
              to="/case-studies" 
              className="block py-2 text-wiiseng-gray hover:text-wiiseng-blue"
              onClick={() => setIsMenuOpen(false)}
            >
              Case Studies
            </Link>
            <Button 
              className="bg-wiiseng-blue hover:bg-wiiseng-navy mt-2 w-full"
              onClick={() => handleSectionClick('contact')}
            >
              Contact Us
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
